import { useCallback, useEffect, useRef, useState } from "react";

export const usePopup = (closeOnPathnameChange = true) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const openPopup = useCallback((e) => {
    setAnchorEl(e.detail?.target || e.currentTarget || e.target);
  }, []);
  const closePopup = useCallback(() => {
    setAnchorEl(null);
  }, []);
  const isShown = !!anchorEl;

  const pathname = "window" in global && window.location.pathname;

  // Close popup on route change.
  const refIsFirstCall = useRef(true);
  useEffect(() => {
    if (!closeOnPathnameChange) {
      return;
    }

    if (refIsFirstCall.current) {
      refIsFirstCall.current = false;
      return;
    }

    closePopup();
  }, [pathname, closePopup, closeOnPathnameChange]);

  return {
    anchorEl,
    isShown,
    openPopup,
    closePopup
  };
};
